import { useEffect, useState } from "react";

function useResponsiveHeight() {
  const [heightSize, setHeightSize] = useState(0);

  const handleResize = () => {
    setHeightSize(window.innerHeight);
  };

  useEffect(() => {
    // window.innerHeight 읽기 — 렌더 중 계산 불가한 뷰포트 측정값
    // eslint-disable-next-line react-hooks/set-state-in-effect
    handleResize();
    window.addEventListener("resize", handleResize);

    const root = document.documentElement;
    root.style.setProperty("--responsive-full-height", `${heightSize}px`);

    return () => window.removeEventListener("resize", handleResize);
  }, [heightSize]);

  return heightSize;
}

export default useResponsiveHeight;
